module.exports = __webpack_public_path__ + "static/media/af.133f0a34.png";